import React, { useState } from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import Button from "../../../components/Button";
import { H4 } from "../../../styles/Fonts";
import CustomModal from "../../../components/Modal";
import { useWeb3React } from "@web3-react/core";
import { setReferralCode } from "../../../utils/api/referralApi";

const SetReferralCodeModal: React.FC<{
  isShowModal: boolean;
  setShowModal: (v: boolean) => void;
  setIsSetting: (v: boolean) => void;
  updateReferralCode: () => void;
}> = (props) => {
  const { isShowModal, setShowModal, setIsSetting, updateReferralCode } = props;

  const [code, setCode] = useState<string>("");

  const { account, chainId, provider } = useWeb3React();

  const handleSetCode = async () => {
    if (!account || !code || !chainId || !provider) return;

    setShowModal(false);
    setIsSetting(true);

    await setReferralCode(account, chainId, provider, code);

    setIsSetting(false);
    updateReferralCode();
  };

  return (
    <CustomModal
      show={isShowModal}
      onHide={() => setShowModal(false)}
      title="Set Referral Code"
    >
      <InputContainer>
        <Input
          type="text"
          placeholder="Referral Code"
          onChange={(e) => {
            setCode(e.currentTarget.value);
          }}
        />
      </InputContainer>
      <InfoContainer>
        <Description>
          Set a referral code for your account, earn ...
        </Description>
      </InfoContainer>
      <BtnContainer>
        <Button
          btnType="primary"
          btnText="Set Referral Code"
          onClick={handleSetCode}
          disabled={!code}
          isLoading={false}
        />
      </BtnContainer>
    </CustomModal>
  );
};

export default SetReferralCodeModal;

const BtnContainer = styled.div`
  margin-top: 24px;
  button {
    border-radius: 4px;
    font-size: 16px;
    line-height: 22px;
  }
`;

const Description = styled(H4)`
  color: ${Colors.gray3};
  font-size: 13px;
  line-height: 22px;
`;

const InputContainer = styled.div`
  flex: 1 1 60px;
  padding: 6px 12px 6px 12px;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  border: 1px solid ${Colors.gray4};
  margin-top: 12px;
`;

const Input = styled.input`
  width: 100%;
  border: none;
  background-color: transparent;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: ${Colors.ivory};
  :focus {
    border: none;
    outline: none;
  }
`;

const InfoContainer = styled.div`
  margin-top: 20px;
`;
